import { useMutation, useQueryClient } from '@tanstack/react-query';
import { integrationsService } from '@/services/integrations';

export function useReprocessIntegration() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (policyId: string) => integrationsService.reprocessIntegration(policyId),
    onSuccess: (_data, policyId) => {
      queryClient.invalidateQueries({ queryKey: ['integration-details', policyId] });
      queryClient.invalidateQueries({ queryKey: ['integrations'] });
    },
  });
}
